import React, { Component } from 'react';
import { Container, Image, Modal, Button, Form, Dropdown, Row, Col, DropdownButton, Pagination, OverlayTrigger, Tooltip } from 'react-bootstrap';
import LogoImage from '../../Images/logo-wirebit-transfer.png';
import { store } from 'react-notifications-component';
import NumberFormat from 'react-number-format';
import { Bounce } from 'react-activity';
import ReactNotification from 'react-notifications-component';

import CopyClip from '../../Images/copy-clip.png';
import ExternalLink from '../../Images/external-link.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';


import Backend from '../../Backend';
import Connection from '../../Calls';

import flechitas from '../../Images/Transfer-03.png'
import logoCuadrado from '../../Images/LogoWirebitTransfer_Azul.png'
import logoPlano from '../../Images/LogoWirebitTransfer-03.png'
import arrowDown from '../../Images/arrow-down.svg'
import GAuth from '../../Images/gauth.png'

// import tsu from '../../Images/tsunade.png'
// import hin from '../../Images/hinata.png'



import Modaltwofa from '../2fa/index'
import '../2fa/index.css'

export default class RequestTranferModal extends Component{
    constructor(props){
        super(props)
        this.state={
            wallets:[],

            fromWallet:'',
            toWallet:'',
            selectedCurrency:'',
            description:'',
            idTooltip:'',
            ClipboardText:props.traductions.modalRequest.copyToClip,
            idTooltip:'',
            link:'',
            linkIsReady:false,
            alias:'',
        }
    }
    componentWillMount() {
        this.setState({alias: localStorage.getItem('alias')})
        this.getWallets(1,100000,'')
    }

    getWallets(value_paginaActual, value_numeroFilas, valueSearch) {
        const self = this;
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
          Backend.Check2FA(localStorage.getItem('email'), localStorage.getItem('token'),response.payload.r01, response =>{
            if(response.status.code === "0"){
              if(response.payload.status === "enabled"){
                this.setState({TWOfa:true})
              }else{
                this.setState({TWOfa:false})
              }
            }else{

            }
          })
          Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), valueSearch, value_paginaActual, value_numeroFilas, response.payload.r01, response => {
            if (response.status.code === "0") {
              self.setState({
                wallets: response.payload,
                dataLength:response.payload.length
              });
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
            }
            self.setState({showload:false})
          });
        });
      }

    selectWallet(wallet){
    this.props.coinArr.forEach((item, i) => {
      if(item.symbol == wallet.coin){
        this.setState({fromWallet:wallet,toWallet:'', selectedCurrency:wallet.coin,usdPrice: item.usd_price})
      }
        });
    }

    renderListWallets() {
        const self = this;
        var wallets = [];
        self.state.wallets.forEach(function (item) {
          wallets.push(
            <Dropdown.Item onClick={()=>self.selectWallet(item)} as="button">
              <Image src={require("../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
              {item.alias}
            </Dropdown.Item>
          );
        });
        return wallets;
      }

    calculateCrypto(){
        var calculoCrypto;
        if(this.state.selectedCurrency == 'usd'){
            var calculoCrypto = (((this.state.amountW) * (1- (this.props.planInfo.transfer_internal/100) )) / this.state.usdPrice).toFixed(8)
        } else{
            var calculoCrypto = ((this.state.amountW) * (1- (this.props.planInfo.transfer_internal/100) )).toFixed(8)
        }
        return calculoCrypto
    }

    calculateUSD(){
        var calculoUsd;
        if(this.state.selectedCurrency == 'usd'){
            var calculoUsd = ((this.state.amountW) * (1- (Number(this.props.planInfo.transfer_internal)/100))).toFixed(2)
        } else{
            var amountFee = (Number(this.props.planInfo.transfer_internal) == 0) ? this.state.amountW :((this.state.amountW) * (1- (Number(this.props.planInfo.transfer_internal)/100)))
            var calculoUsd = this.formatMoney(amountFee * this.state.usdPrice)
        }
        return calculoUsd
    }

    cryptoSend(value){
        var calculoCrypto;
        if(this.state.selectedCurrency == 'usd'){
          var calculoCrypto = ((value) / this.state.usdPrice).toFixed(8)
        } else{
          var calculoCrypto = value
        }
          this.setState({
            amountW: value,
            cryptoSend: calculoCrypto
          })
      }

    formatMoney(n,c,d,t){
        var n = n,
            c = isNaN(c = Math.abs(c)) ? 2 : c,
            d = d == undefined ? "." : d,
            t = t == undefined ? "," : t,
            s = n < 0 ? "-$" : "$",
            i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
            j = (j = i.length) > 3 ? j % 3 : 0;
           return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    CopyToClipboard(){
        const self=this
        self.setState({ClipboardText:self.props.traductions.modalRequest.copiedToClip, idTooltip:'tooltip-right fade-in'});
        setTimeout(function(){ self.setState({ idTooltip:' tooltip-right fade-out'}) }, 1000)
        setTimeout(function(){ self.setState({ClipboardText:self.props.traductions.modalRequest.copyToClip,idTooltip:''}) }, 2000)

      }

    getLink(){
        var link = process.env.REACT_APP_ME_WEB + 'transfer?alias='+ encodeURIComponent(this.state.alias) + '&wallet=' + encodeURIComponent(this.state.fromWallet.alias) + '&amount='+ encodeURIComponent(this.state.cryptoSend) + '&currency=' + encodeURIComponent(this.state.fromWallet.coin) + '&description='+ encodeURIComponent(this.state.description)
        if(this.state.link != link) this.setState({link:link})

        if(this.state.alias && this.state.fromWallet.alias && this.state.amountW && this.state.selectedCurrency && this.state.description){
          if(this.state.linkIsReady==false) this.setState({linkIsReady:true})
          return (
            <div className="three-dots-txid">
              <a  target={"_blank"} href={link}>{link}</a>
            </div>
          )
        }else{
          if(this.state.linkIsReady==true) this.setState({linkIsReady:false})
          return (
            <div className="three-dots-txid">
              <a  target={"_blank"} >{link}</a>
            </div>
          )
        }

    }

    render(){
        return(
            <Modal className="modal-transfer" centered aria-labelledby="contained-modal-title-vcenter" show={this.props.showModalRequestTransfer} onHide={() => { this.props.handleClose(); }}>
                <Modal.Body style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    {/* <Col>
                      <Image style={{height:'20em', marginRight:'-12em'}} src={hin}/>
                    </Col> */}
                    <Col className='Modal-body' >
                        <Row>
                            <Image src={logoPlano} style={{width:'25%',marginBottom:'2em'}}/>
                        </Row>
                        <Row className='AccountAlias' >
                            <Col >
                                <Row><Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.modalRequest.title}</Form.Label></Row>
                                <Row>{this.state.alias}</Row>
                            </Col>
                        </Row >
                        {/* Dropdown wallets */}

                        <Row style={{marginTop:18}}>
                            <Col md={6} className='virtual_exchange_dropdown'>
                                <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.modalRequest.L_ToWallets}</Form.Label>
                                <Dropdown>
                                  <Dropdown.Toggle id="dropdown-custom-1">
                                      {
                                      (this.state.fromWallet)
                                      ?
                                      <>
                                          <Image src={require("../../CryptoIcons/" + this.state.fromWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                                          {this.state.fromWallet.alias}
                                      </>
                                      :this.props.traductions.modalRequest.S_Wallets
                                      }
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                      {this.renderListWallets()}
                                  </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        {/* AMOUNT */}

                        <Row style={{marginTop:20}}>
                        {
                            (this.state.fromWallet && this.props.planInfo)?
                            <Col  md={6} className='virtual_exchange_dropdown'>
                                <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.modalRequest.L_Amount}:</Form.Label>
                                <Form.Group as={Row}>
                                    <Col className="virtual_exchange_dropdown">
                                        <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                                            {
                                            (this.state.selectedCurrency == 'usd')
                                            ? <NumberFormat className='btc-format-input' placeholder={this.props.traductions.modalRequest.P_Amount} decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                                            : <NumberFormat className='btc-format-input' placeholder={this.state.fromWallet.coin.toUpperCase() + ' Amount'} decimalScale={8} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                                            }
                                            <Button className={(this.state.selectedCurrency === this.state.fromWallet.coin) ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: this.state.fromWallet.coin }) }}>{this.state.fromWallet.coin.toUpperCase()}</Button>
                                            <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                                        </div>
                                        <Form.Label className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error" }style={{width:'100%'}}>
                                          <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"} style={{float:'left'}}>{this.props.traductions.modalRequest.N_Amount1} {this.calculateCrypto()} {this.state.fromWallet.coin}</p>
                                        </Form.Label>
                                        <Form.Label className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error" }style={{width:'100%',marginTop:'12px'}}>
                                          <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"} style={{float:'left'}}>{this.props.traductions.modalRequest.N_Amount3} {this.calculateUSD()} usd</p>
                                        </Form.Label>

                                        {/* <div className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error"}>
                                            <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"} style={{marginBottom: 2}}>You will request {this.calculateCrypto()*this.state.accountFee} {this.state.fromWallet.coin}</p>
                                            <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>Approximately {this.calculateUSD()} usd</p>
                                        </div> */}
                                    </Col>
                                </Form.Group>
                            </Col >
                            :
                            <Col  md={6} className='virtual_exchange_dropdown'>
                                {/* <Form.Label style={{width:'100%',margin:-4}}>
                                    <p className="virtual_exchange_information_wallets_text" style={{float:'left'}}>Amount</p>
                                    <p className='text-available-modal' style={{float:'right'}}>Available: {this.state.fromWallet.balance} {this.state.fromWallet.coin}</p>
                                </Form.Label> */}
                                <Form.Label className="virtual_exchange_information_wallets_text">Amount:</Form.Label>
                                <Form.Group as={Row}>
                                    <Col className="virtual_exchange_dropdown">
                                        <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                                            <NumberFormat disabled className='btc-format-input' placeholder={this.props.traductions.modalRequest.P_Amount} decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                                            <Button disabled variant="link" className={"boton-seleccionar-currency"}>-</Button>
                                            <Button disabled className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                                        </div>
                                    </Col>
                                </Form.Group>
                            </Col>
                        }

                            </Row>

                        {/* DESCRIPCION */}

                        <Row>
                            <Col md={6} className='virtual_exchange_dropdown'>
                                <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.modalRequest.L_Desc}</Form.Label>
                                <Form.Control type="text" placeholder={this.props.traductions.modalRequest.P_Desc} maxlength="64" value={this.state.description} onChange={(description) => { this.setState({ description: description.target.value }) }} />
                                <Form.Label style={{width:'100%',margin:-4}}>
                                    <p className="virtual_exchange_information_wallets_text" style={{float:'left'}}>{this.state.description.length}/64</p>
                                </Form.Label>
                            </Col>
                        </Row>

                        {/* CLIPBOARD */}
                        <Row style={{marginTop:20}}>
                          {this.getLink()}

                            <OverlayTrigger placement={'right'} overlay={
                                <Tooltip className={this.state.idTooltip}>
                                {this.state.ClipboardText}
                                </Tooltip>
                                }>
                                    <CopyToClipboard text={this.state.link}>
                                        <button disabled={!this.state.linkIsReady} className='clipboardimg' onClick={()=>{ this.CopyToClipboard()}}>
                                          <Image src={CopyClip}/>
                                        </button>
                                    </CopyToClipboard>
                            </OverlayTrigger>

                            <button disabled={!this.state.linkIsReady} className='clipboardimg' onClick={()=>window.open(this.state.link, '_blank')}>
                              <Image src={ExternalLink}/>
                            </button>
                        </Row>
                    </Col>
                    {/* <Col>
                        <Image style={{height:'20em', marginLeft:'-12em'}} src={tsu}/>
                    </Col> */}
                </Modal.Body>
            </Modal>
        )
    }

}
